// extracted by mini-css-extract-plugin
export var chapterTitle = "menu-module--chapterTitle---7tzB";
export var link = "menu-module--link--jB7jH";
export var linkActive = "menu-module--linkActive--Mui76";
export var menu = "menu-module--menu--XsD+N";
export var sectionLink = "menu-module--sectionLink--9cGdd";
export var sectionLinkActive = "menu-module--sectionLinkActive--RH08Z";
export var wrapper = "menu-module--wrapper--2BHpe";